<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link :to="{ path: '/ordemServico', query: $route.query }">
        Manutenção/ordem Serviço
      </router-link>
      <label class="labelBar"> / </label>
      <label> Editar</label>
    </div>
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" sm="4">
            <v-subheader><strong>Prioridade</strong></v-subheader>
            <hr />
            <div class="flex-center">
              <v-radio-group v-model="prioridade" row>
                <v-radio label="Normal" value="N"></v-radio>
                <v-radio label="Emergencial" value="E"></v-radio>
              </v-radio-group>
            </div>
          </v-col>
          <v-col cols="12" sm="4" md="4" align="right">
            <v-subheader
              >Relato ref Chamado N º<strong>{{
                ordemServico.idChamado
              }}</strong></v-subheader
            >
            <hr />
            <div class="flex-center">
              <v-textarea
                v-model="ordemServico.chamadoManutencao"
                rows="2"
                auto-grow
                readonly
              ></v-textarea>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="unidadeAdmSelected"
              :items="filteredUnidAdm"
              label="Unidade Administrativa *"
              item-text="descricao"
              item-value="id"
              persistent-hint
              return-object
              :readonly="readOnly"
              :rules="[(v) => !!v || 'A Unidade Administrativa é obrigatória']"
              required
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="equipamentoSelected"
              :items="equipamentos"
              label="Equipamento *"
              item-text="centroCusto"
              item-value="id"
              persistent-hint
              return-object
              v-on:change="changeEquipamento()"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O Equipamento é obrigatório']"
              required
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="4">
            <v-subheader><strong>Tipo OS</strong></v-subheader>
            <hr />
            <div class="flex-center">
              <v-radio-group v-model="tipo" v-on:change="changeTipo()" row>
                <v-radio label="Corretiva" value="CR"></v-radio>
                <v-radio label="Preventiva" value="PV"></v-radio>
                <v-radio label="Preditiva" value="PD"></v-radio>
              </v-radio-group>
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="planoManutencaoSelected"
              :items="planosEquipamento"
              label="Plano manutenção"
              item-text="descricao"
              item-value="id"
              persistent-hint
              return-object
              v-on:change="changePlano()"
              :loading="loadingPlanos"
              :readonly="readOnly"
              :disabled="tipo != 'PV'"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="periodicidadeSelected"
              :items="periodicidadePlanos"
              label="Periodicidade"
              item-text="quantidadeHoras"
              item-value="id"
              persistent-hint
              return-object
              :loading="loadingPeriodos"
              v-on:change="changePeriodo()"
              :readonly="readOnly"
              :disabled="!planoManutencaoSelected"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row align="right">
          <v-col cols="12" sm="6" md="4" class="text-left">
            <v-menu
              v-model="menuData1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="computedDataIni"
                  label="Data inicio"
                  prepend-icon="mdi-calendar"
                  v-mask="['##/##/####']"
                  maxlength="10"
                  v-bind="attrs"
                  v-on="on"
                  @input="onInputDate1"
                  @click:clear="dataIni = null"
                  clearable
                  :rules="[(v) => !!v || 'A data inicial é obrigatória']"
                  required
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dataIni"
                @input="menuData1 = false"
                @change="dateChangeDataIni"
                locale="pt-br"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="4" class="text-left">
            <v-menu
              v-model="menuData2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="computedDataFim"
                  label="Data fim"
                  prepend-icon="mdi-calendar"
                  v-mask="['##/##/####']"
                  maxlength="10"
                  v-bind="attrs"
                  v-on="on"
                  @input="onInputDate2"
                  @click:clear="dataFim = null"
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dataFim"
                @input="menuData2 = false"
                @change="dateChangeDataFim"
                locale="pt-br"
                forma
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-text-field
              label="Hora Inicial"
              v-model="horaInicio"
              v-mask="['##:##']"
              :counter="5"
              maxlength="5"
              :rules="[
                (v) => !!v || 'A Hora Inicial é obrigatória',
                (v) =>
                  (v && this.validaHora(v)) || 'A Hora Inicial deve ser válida',
              ]"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-text-field
              label="Hora Final"
              v-model="horaFim"
              v-mask="['##:##']"
              :counter="5"
              maxlength="5"
              :rules="[
                (v) => {
                  if (!v) return true;
                  return validaHora(v) || 'A Hora Final deve ser válida';
                },
              ]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="right">
          <v-col cols="12" sm="6" md="3" class="text-left">
            <v-text-field
              label="Horímetro Inicial"
              v-model.number="horimetroInicial"
              class="compact-input"
              type="number"
              :rules="[
                rules.naoNegativo,
                (v) => !!v || 'O horimetro é obrigatório',
              ]"
              required
            />
          </v-col>
          <v-col cols="12" sm="6" md="3" class="text-left">
            <v-text-field
              label="Horímetro Final"
              v-model.number="horimetroFinal"
              class="compact-input"
              type="number"
              :rules="[rules.naoNegativo]"
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="localizacaoSelected"
              :items="localizacoes"
              label="Localizações *"
              item-text="nome"
              item-value="id"
              persistent-hint
              return-object
              :readonly="readOnly"
              :rules="[(v) => !!v || 'A Localização é obrigatória']"
              required
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12">
            <v-textarea
              label="Informações Adicionais"
              v-model="informacoesAdicionais"
              v-uppercase
              clear-icon="mdi-close-circle"
              maxlength="200"
              counter
              rows="1"
              clearable
              auto-grow
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="mecanicoSelected"
              :items="mecanicos"
              label="Mecânico *"
              item-text="nome"
              item-value="id"
              persistent-hint
              return-object
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O Mecânico é obrigatório']"
              required
              :filter="customFilter"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="lubrificadorSelected"
              :items="mecanicos"
              label="Lubrificador"
              item-text="nome"
              item-value="id"
              persistent-hint
              return-object
              :rules="[(v) => !!v || 'O Lubrificador é obrigatório']"
              required
              :readonly="readOnly"
              :filter="customFilter"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="eletricistaSelected"
              :items="mecanicos"
              label="Eletricista"
              item-text="nome"
              item-value="id"
              persistent-hint
              return-object
              :filter="customFilter"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O Eletricista é obrigatório']"
              required
            >
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center" v-if="tipo != 'PV'">
        <v-col class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="info"
                fab
                small
                v-bind="attrs"
                v-on="on"
                @click="addServico()"
                class="white--text"
              >
                <v-icon> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Adicionar Serviço</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-snackbar v-model="errorMessage" color="error" timeout="3000"
        >{{ errorMessageValue }}
      </v-snackbar>

      <v-form ref="formProd" v-model="valid" lazy-validation>
        <v-card>
          <v-data-table
            :headers="filteredHeaders"
            hide-default-footer
            :loading="loadingServicos"
            :items="servicosL"
            :items-per-page="-1"
          >
            <template v-slot:item.detalhe="{ item }">
              <v-text-field v-model="item.detalhe"> </v-text-field>
            </template>
            <template v-slot:item.execucao="{ item }">
              <div v-if="!item.editingExecucao">
                <div
                  @click="item.editingExecucao = true"
                  style="cursor: pointer"
                >
                  {{
                    (item.execucao && item.execucao.valor) ||
                    execucoes.find((e) => e.id === item.execucao).valor
                  }}
                </div>
              </div>
              <v-autocomplete
                v-else
                v-model="item.execucao"
                :items="execucoes"
                item-text="valor"
                item-value="id"
                persistent-hint
                return-object
                :readonly="readOnly"
                autofocus
                @blur="
                  () => {
                    item.editingExecucao = false;
                  }
                "
                @change="
                  (val) => {
                    changeServico(item.index, val);
                    item.editingExecucao = false;
                  }
                "
              >
              </v-autocomplete>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="error"
                    @click="removeServico(item.index)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-close-thick
                  </v-icon>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </template>

            <template v-slot:item.index="{ item }">
              {{ item.index + 1 }}
            </template>
            <template v-slot:body.append>
              <tr>
                <td
                  :colspan="filteredHeaders.length"
                  class="text-right font-weight-medium"
                >
                  Total de itens: {{ servicosL.length }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-form>

      <v-row align="center-left">
        <v-col class="text-right">
          <v-speed-dial bottom right fixed class="os-action-speed-dial">
            <template v-slot:activator>
              <v-btn v-model="fab" color="blue darken-2" dark fab>
                <v-icon v-if="fab">mdi-close</v-icon>
                <v-icon v-else>done</v-icon>
              </v-btn>
            </template>
            <v-btn
              @click="enviar"
              color="success"
              class="os-action-button"
              :disabled="ordemServico.status != 'EA'"
            >
              Salvar
            </v-btn>
            <v-btn
              :to="{ path: '/ordemServico', query: $route.query }"
              color="error"
              class="os-action-button"
            >
              Voltar
            </v-btn>
            <v-btn
              @click="executar"
              color="primary"
              class="os-action-button"
              v-if="
                !todosExecutados &&
                servicosL.length > 0 &&
                ordemServico.status == 'EA'
              "
            >
              Executar Todos
            </v-btn>
            <v-btn
              @click="naoAutorizar"
              color="secondary"
              class="os-action-button"
              v-if="ordemServico.status == 'AA' && isApproving(idModulo)"
            >
              NÃO AUTORIZAR OS
            </v-btn>
            <v-btn
              @click="showModalAcoes = true"
              color="primary"
              class="os-action-button"
              v-if="ordemServico.status == 'AA' && isApproving(idModulo)"
            >
              Autorizar OS
            </v-btn>
            <v-btn
              @click="confirmar"
              color="primary"
              class="os-action-button"
              v-if="ordemServico.status == 'EA' && servicosL.length > 0"
            >
              Finalizar OS
            </v-btn>
          </v-speed-dial>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
    <v-dialog
      style="z-index: 9999"
      v-model="showModal"
      persistent
      max-width="1000px"
      ><v-card>
        <v-card-title>
          <span class="headline">Adicionar Serviço</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form2" v-model="validFrm2" lazy-validation>
              <produto
                ref="prdAdd"
                :servicosL="servicosL"
                :showModal="showModal"
              />
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions
          style="position: sticky; bottom: 0; background: white; z-index: 1"
        >
          <v-spacer></v-spacer>
          <v-btn color="error" class="mr-4" @click="showModal = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      style="z-index: 9999"
      v-model="showModalAcoes"
      persistent
      max-width="1000px"
      ><v-card>
        <v-card-title>
          <span class="headline"
            >{{ ordemServico.status == "AA" ? "Autorizar" : "Finalizar" }} Ordem
            Serviço {{ this.ordemServico.id }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form>
              <v-row>
                <v-col cols="12" sm="12"
                  ><v-subheader
                    ><strong
                      >Deseja realmente
                      {{
                        ordemServico.status == "AA" ? "Autorizar" : "Finalizar"
                      }}
                      a ordem de serviço: {{ this.ordemServico.id }}?</strong
                    ></v-subheader
                  >
                  <hr />
                </v-col>
              </v-row>
            </v-form>
            <v-row align="center-left">
              <v-col class="text-right">
                <v-btn
                  @click="finalizar"
                  color="success"
                  class="mr-4"
                  v-if="ordemServico.status != 'AA'"
                >
                  Finalizar
                </v-btn>
                <v-btn
                  @click="autorizar"
                  color="success"
                  class="mr-4"
                  v-if="ordemServico.status == 'AA'"
                >
                  Autorizar
                </v-btn>
                <v-btn
                  @click="showModalAcoes = false"
                  color="error"
                  class="mr-4"
                >
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  editarOrdemServicoAsync,
  executarOrdemServicoAsync,
  finalizarOrdemServicoAsync,
  autorizarOrdemServicoAsync,
  naoAutorizarOrdemServicoAsync,
} from "../../../services/ordemServicoService";
import { mapState, mapActions } from "vuex";
import moment from "moment";
import Produto from "./Produto";
import {
  ordenarItensPlanoManutencao,
  reindexarItensPlanoManutencao,
} from "../../../utils/planoManutencaoItens";
import { getUserRoles, getUserPermission } from "@/services/loginService";

export default {
  name: "editarOrdemServico",
  data: () => ({
    idModulo: 17,
    readOnly: false,
    regras: [],
    overlay: false,
    valid: true,
    tipo: "CR",
    prioridade: "N",
    unidadeAdmSelected: null,
    equipamentoSelected: null,
    dataIni: null,
    dataFim: null,
    horimetroInicial: null,
    horimetroFinal: null,
    horaInicio: null,
    horaFim: null,
    planoManutencaoSelected: null,
    periodicidadeSelected: null,
    mecanicoSelected: null,
    eletricistaSelected: null,
    lubrificadorSelected: null,
    localizacaoSelected: null,
    loadingPlanos: false,
    loadingPeriodos: false,
    loadingServicos: false,
    informacoesAdicionais: null,
    menuData1: false,
    menuData2: false,
    showModal: false,
    showModalAcoes: false,
    errorMessage: false,
    errorMessageValue: null,
    servicosL: [],
    execucoes: [
      { id: 0, valor: "pendente" },
      { id: 1, valor: "executado" },
    ],
    headersBase: [
      { text: "Item", value: "index", sortable: false },
      { text: "Compartimento", value: "compartimento", sortable: false },
      { text: "Serviço", value: "descricao", sortable: false },
      { text: "Coódigo", value: "codigo", sortable: false },
      { text: "Detalhar Serviço", value: "detalhe", sortable: false },
      {
        text: "Execução",
        value: "execucao",
        width: "15%",
      },
      { text: "", value: "actions", sortable: false },
    ],
    rules: {
      naoNegativo: (v) =>
        v === null || v === "" || v >= 0 || "Não pode ser negativo",
    },
  }),
  computed: {
    ...mapState("equipamento", ["equipamentos"]),
    ...mapState("local", ["locais"]),
    ...mapState("mecanico", ["mecanicos"]),
    ...mapState("equipamento", ["equipamentos"]),
    ...mapState("localizacao", ["localizacoes"]),
    ...mapState("planoManutencao", ["planosEquipamento"]),
    ...mapState("periodicidade", ["periodicidadePlanos"]),
    ...mapState("servicoPlano", ["servicosPlanoPeriodos"]),
    ...mapState("ordemServico", ["ordemServico"]),
    filteredUnidAdm() {
      return this.locais.filter((lc) => {
        return (
          (lc.idTipoLocais === 2 || lc.idTipoLocais === 3) && lc.ativo === true
        );
      });
    },

    computedDataIni() {
      return this.dataIni ? moment(this.dataIni).format("DD/MM/YYYY") : null;
    },
    computedDataFim() {
      return this.dataFim ? moment(this.dataFim).format("DD/MM/YYYY") : null;
    },
    filteredHeaders() {
      return this.headersBase.filter((header) => {
        if (
          !header.value ||
          header.value === "actions" ||
          header.value === "detalhe"
        )
          return true; // Sempre mostra ações

        // Verifica se existe pelo menos um valor não nulo ou não vazio para essa coluna
        return this.servicosL.some((item) => {
          const val = item[header.value];
          return val !== null && val !== undefined && val !== "";
        });
      });
    },
    todosExecutados() {
      return (
        this.servicosL.every((item) => item.execucao) &&
        this.servicosL.length > 0
      );
    },
  },
  methods: {
    ...mapActions("produto", ["atualizarServicosInterno"]),
    ...mapActions("planoManutencao", ["atualizarPlanosEquipamento"]),
    ...mapActions("periodicidade", ["atualizarPeriodoPorPlano"]),
    ...mapActions("servicoPlano", ["atualizarServicosPlanoPeriodos"]),
    ...mapActions("ordemServico", [
      "atualizarOrdemServico",
      "updateOrdemServico",
    ]),
    async enviar() {
      if (this.servicosL == null || this.servicosL.length <= 0) {
        this.errorMessageValue = "Adicione os serviços!";
        this.errorMessage = true;
      } else if (this.$refs.form.validate()) {
        this.overlay = true;
        try {
          const resposta = await editarOrdemServicoAsync(
            this.ordemServico.id,
            this.tipo,
            this.prioridade,
            this.unidadeAdmSelected.id,
            this.equipamentoSelected.id,
            this.planoManutencaoSelected
              ? this.planoManutencaoSelected.id
              : null,
            this.planoManutencaoSelected ? this.periodicidadeSelected.id : null,
            this.mecanicoSelected.id,
            this.lubrificadorSelected.id,
            this.eletricistaSelected.id,
            this.localizacaoSelected.id,
            this.informacoesAdicionais,
            this.dataIni,
            this.dataFim,
            this.horaInicio,
            this.horaFim,
            this.horimetroInicial,
            this.horimetroFinal === "" ? null : this.horimetroFinal,
            this.servicosL
          );

          if (!resposta || resposta?.status != 200) {
            this.$alert(
              resposta.message || "",
              "Descupe, falha na operação!",
              "error"
            );
          } else {
            this.$store.dispatch("ui/showSnackbar", {
              text: "Atualizado com sucesso!",
              color: "success",
              timeout: 3000,
            });
            this.$router.push({
              path: "/ordemServico",
              query: this.$route.query,
            });
          }
        } finally {
          this.overlay = false;
        }
      }
    },
    addServico: function () {
      this.showModal = true;
    },
    removeServico(index) {
      this.servicosL = reindexarItensPlanoManutencao(
        this.servicosL.filter((p) => p.index != index)
      );
    },

    changeServico(index, execucao) {
      const rowIdx = this.servicosL.findIndex((s) => s.index === index);
      if (rowIdx === -1) return;
      this.$set(this.servicosL[rowIdx], "execucao", execucao);
      this.$set(
        this.servicosL[rowIdx],
        "executado",
        execucao.id == 0 ? false : true
      );
    },
    async obterListas() {
      await this.atualizarServicosInterno();
    },

    onInputDate1(val) {
      if (val.length == 10) {
        const newDate = moment(val, "DD/MM/YYYY");
        if (newDate.isValid() && newDate <= new Date()) {
          this.dataIni = moment(val, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataIni(date) {
      this.dataIni = date;
    },
    onInputDate2(val) {
      if (val.length == 10) {
        const newDate = moment(val, "DD/MM/YYYY");
        if (newDate.isValid()) {
          this.dataFim = moment(val, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataFim(date) {
      this.dataFim = date;
    },

    validaHora(val) {
      if (/^\d{2}:\d{2}$/.test(val)) {
        var [h, m] = val.split(":").map(Number);
        if (h >= 0 && h <= 23 && m >= 0 && m <= 59) {
          return true;
        }
      }
      return false;
    },
    async changeTipo() {
      if (this.tipo == "PV" && this.equipamentoSelected) {
        this.loadingPlanos = true;
        await this.atualizarPlanosEquipamento(this.equipamentoSelected.id);
        this.loadingPlanos = false;
      } else {
        this.planoManutencaoSelected = null;
        this.periodicidadeSelected = null;
        this.servicosL = [];
      }
    },
    async changeEquipamento() {
      this.planoManutencaoSelected = null;
      this.periodicidadeSelected = null;
      this.servicosL = [];
      if (this.tipo == "PV") {
        this.loadingPlanos = true;
        await this.atualizarPlanosEquipamento(this.equipamentoSelected.id);
        this.loadingPlanos = false;
      }
    },
    async changePlano() {
      const idPeriodicidadeAtual = this.periodicidadeSelected
        ? this.periodicidadeSelected.id
        : null;
      this.servicosL = [];

      if (!this.planoManutencaoSelected) {
        this.periodicidadeSelected = null;
        return;
      }

      this.loadingPeriodos = true;
      await this.atualizarPeriodoPorPlano(this.planoManutencaoSelected.id);
      this.loadingPeriodos = false;

      if (!idPeriodicidadeAtual) {
        this.periodicidadeSelected = null;
        return;
      }

      const periodicidadeValida = this.periodicidadePlanos.find(
        (p) => p.id === idPeriodicidadeAtual
      );
      this.periodicidadeSelected = periodicidadeValida || null;

      if (periodicidadeValida) {
        await this.changePeriodo();
      }
    },
    async changePeriodo() {
      if (!this.planoManutencaoSelected || !this.periodicidadeSelected) {
        this.servicosL = [];
        return;
      }

      this.loadingServicos = true;
      await this.atualizarServicosPlanoPeriodos({
        idPlano: this.planoManutencaoSelected.id,
        idPeriodicidade: this.periodicidadeSelected.id,
      });

      const servicosOrdenados = ordenarItensPlanoManutencao(
        this.servicosPlanoPeriodos
      );
      this.servicosL = reindexarItensPlanoManutencao(servicosOrdenados).map(
        (s) => ({
          ...s,
          execucao: 0,
          executado: false,
          editingExecucao: false,
          idServicoPlano: s.id,
          id: 0,
        })
      );
      this.loadingServicos = false;
    },
    findLocal(idLocal) {
      return this.locais.find((l) => l.id === idLocal);
    },
    findEquipamento(idEquipamento) {
      return this.equipamentos.find((e) => e.id === idEquipamento);
    },
    findMecanico(idMecanico) {
      return this.mecanicos.find((m) => m.id === idMecanico);
    },
    findLocalizacao(idLocalizacao) {
      return this.localizacoes.find((l) => l.id === idLocalizacao);
    },
    findPlanoManutencao(idPlano) {
      return this.planosEquipamento.find((p) => p.id === idPlano);
    },
    findPeriodicidade(idPeriodicidade) {
      return this.periodicidadePlanos.find((p) => p.id === idPeriodicidade);
    },
    async autorizar() {
      this.showModalAcoes = false;
      this.overlay = true;
      const resposta = await autorizarOrdemServicoAsync(
        this.ordemServico.id,
        this.tipo,
        this.prioridade,
        this.unidadeAdmSelected.id,
        this.equipamentoSelected.id,
        this.planoManutencaoSelected ? this.planoManutencaoSelected.id : null,
        this.periodicidadeSelected ? this.periodicidadeSelected.id : null,
        this.mecanicoSelected.id,
        this.lubrificadorSelected.id,
        this.eletricistaSelected.id,
        this.localizacaoSelected.id,
        this.informacoesAdicionais,
        this.dataIni,
        this.dataFim,
        this.horaInicio,
        this.horaFim,
        this.horimetroInicial,
        this.horimetroFinal,
        this.servicosL
      );
      if (resposta?.status && resposta.status != 200) {
        this.overlay = false;
        this.$alert(
          resposta.message || "",
          "Descupe, falha na operação!",
          "error"
        );
      } else {
        this.overlay = false;
        this.$store.dispatch("ui/showSnackbar", {
          text: "OS autorizada com sucesso!",
          color: "success",
          timeout: 3000,
        });
        this.$router.push({ path: "/ordemServico", query: this.$route.query });
      }
    },
    async naoAutorizar() {
      try {
        await this.$confirm(
          "A OS voltará para Em Aberto e poderá ser editada. Deseja continuar?",
          "Não autorizar OS?",
          {
            confirmButtonText: "Sim, não autorizar",
            cancelButtonText: "Cancelar",
            type: "warning",
          }
        );

        this.overlay = true;
        const resposta = await naoAutorizarOrdemServicoAsync(
          this.ordemServico.id
        );

        if (!resposta || resposta.status != 200) {
          this.$alert(
            resposta?.message || "",
            "Desculpe, falha na operação!",
            "error"
          );
          return;
        }

        this.$set(this.ordemServico, "status", "EA");
        this.atualizarOrdemServico(this.ordemServico);
        this.updateOrdemServico(this.ordemServico);
        this.$store.dispatch("ui/showSnackbar", {
          text: "OS devolvida para Em Aberto!",
          color: "success",
          timeout: 3000,
        });
      } catch (erro) {
        return;
      } finally {
        this.overlay = false;
      }
    },
    async executar() {
      if (this.servicosL == null || this.servicosL.length <= 0) {
        this.errorMessageValue = "Adicione os serviços!";
        this.errorMessage = true;
      } else if (this.$refs.form.validate()) {
        try {
          await this.$confirm(
            "Essa ação marcará todos os itens como 'Executado'. Deseja continuar?",
            "Executar todos os itens?",
            {
              confirmButtonText: "Sim, executar!",
              cancelButtonText: "Cancelar",
              type: "warning",
            }
          );
          this.overlay = true;
          this.servicosL.forEach((s) => (s.execucao = s.executado = true));
          const resposta = await executarOrdemServicoAsync(
            this.ordemServico.id,
            this.tipo,
            this.prioridade,
            this.unidadeAdmSelected.id,
            this.equipamentoSelected.id,
            this.planoManutencaoSelected
              ? this.planoManutencaoSelected.id
              : null,
            this.periodicidadeSelected ? this.periodicidadeSelected.id : null,
            this.mecanicoSelected.id,
            this.lubrificadorSelected.id,
            this.eletricistaSelected.id,
            this.localizacaoSelected.id,
            this.informacoesAdicionais,
            this.dataIni,
            this.dataFim,
            this.horaInicio,
            this.horaFim,
            this.horimetroInicial,
            this.horimetroFinal,
            this.servicosL
          );
          if (resposta?.status && resposta.status != 200) {
            this.overlay = false;
            this.$alert(
              resposta.message || "",
              "Descupe, falha na operação!",
              "error"
            );
          } else {
            this.servicosL = this.servicosL.map((s) => ({
              ...s,
              execucao: 1,
              executado: true,
            }));
            this.overlay = false;
            this.$store.dispatch("ui/showSnackbar", {
              text: "Atualizado com sucesso!",
              color: "success",
              timeout: 3000,
            });
            //this.$router.push("/ordemServico");
          }
        } catch (e) {
          return;
        }
      }
    },
    inativar(item) {
      this.acao = "inativar";
      this.item = item;
      this.showModal = true;
    },
    confirmar() {
      if (this.servicosL == null || this.servicosL.length <= 0) {
        this.errorMessageValue = "Adicione os serviços!";
        this.errorMessage = true;
        return;
      } else if (
        this.horimetroFinal == null ||
        this.horimetroFinal <= 0 ||
        this.dataFim == null ||
        this.horaFim == null
      ) {
        var inicio = "Preencha";
        var corpo = "";
        if (this.horimetroFinal == null || this.horimetroFinal <= 0) {
          corpo = "o Horimetro Final";
        }
        if (this.dataFim == null) {
          if (corpo != "") corpo = corpo + ", ";
          corpo = corpo + "a Data Final";
        }
        if (this.horaFim == null) {
          if (corpo != "") corpo = corpo + ", ";
          corpo = corpo + "a Hora Final";
        }
        this.errorMessageValue = inicio + corpo + "!";
        this.errorMessage = true;
        return;
      } else if (this.$refs.form.validate()) {
        this.showModalAcoes = true;
      }
    },
    async finalizar() {
      this.showModalAcoes = false;
      this.overlay = true;
      this.servicosL.forEach((s) => (s.execucao = s.executado = true));
      const resposta = await finalizarOrdemServicoAsync(
        this.ordemServico.id,
        this.tipo,
        this.prioridade,
        this.unidadeAdmSelected.id,
        this.equipamentoSelected.id,
        this.planoManutencaoSelected ? this.planoManutencaoSelected.id : null,
        this.periodicidadeSelected ? this.periodicidadeSelected.id : null,
        this.mecanicoSelected.id,
        this.lubrificadorSelected.id,
        this.eletricistaSelected.id,
        this.localizacaoSelected.id,
        this.informacoesAdicionais,
        this.dataIni,
        this.dataFim,
        this.horaInicio,
        this.horaFim,
        this.horimetroInicial,
        this.horimetroFinal,
        this.servicosL
      );
      if (resposta?.status && resposta.status != 200) {
        this.overlay = false;
        this.$alert(
          resposta.message || "",
          "Descupe, falha na operação!",
          "error"
        );
      } else {
        this.overlay = false;
        this.$store.dispatch("ui/showSnackbar", {
          text: "OS finalizada!",
          color: "success",
          timeout: 3000,
        });
        this.$router.push({ path: "/ordemServico", query: this.$route.query });
      }
    },
    customFilter(item, queryText) {
      const q = (queryText || "").toString().toLowerCase().trim();

      // Se não tem busca, não filtra nada
      if (!q) return true;

      const nome = (item?.nome || "").toString().toLowerCase();
      const cargo = (item?.cargo || "").toString().toLowerCase();

      // itemText é o texto "principal" (nome) que o Vuetify já calcula,
      // mas aqui a gente garante com nome/cargo.
      return nome.includes(q) || cargo.includes(q);
    },
    async carregar() {
      await this.atualizarPlanosEquipamento(this.equipamentoSelected.id);
      await this.atualizarPeriodoPorPlano(this.ordemServico.idPlanoManutencao);
      this.planoManutencaoSelected = this.findPlanoManutencao(
        this.ordemServico.idPlanoManutencao
      );
      this.periodicidadeSelected = this.findPeriodicidade(
        this.ordemServico.idPeriodicidade
      );
      var index = 0;
      this.servicosL = JSON.parse(JSON.stringify(this.ordemServico.itens));
      this.servicosL.forEach((s) => {
        this.$set(s, "index", index++);
        this.$set(s, "execucao", s.executado ? 1 : 0);
        this.$set(s, "editingExecucao", false);
      });
    },
    isApproving(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.aprovar;
    },
  },
  created: function () {
    var index = 0;
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
    this.obterListas();
    this.readOnly = !getUserPermission(this.idModulo);
    this.unidadeAdmSelected =
      this.findLocal(this.ordemServico.idUnidadeAdm) || null;
    this.equipamentoSelected =
      this.findEquipamento(this.ordemServico.idEquipamento) || null;
    this.mecanicoSelected =
      this.findMecanico(this.ordemServico.idMecanico) || null;
    this.lubrificadorSelected =
      this.findMecanico(this.ordemServico.idLubrificador) || null;
    this.eletricistaSelected =
      this.findMecanico(this.ordemServico.idEletricista) || null;
    this.localizacaoSelected =
      this.findLocalizacao(this.ordemServico.idLocalizacao) || null;
    this.informacoesAdicionais = this.ordemServico.informacoesAdicionais;
    this.prioridade = this.ordemServico.prioridade == "Normal" ? "N" : "E";
    this.dataIni = this.ordemServico.dataInicial;
    this.dataFim = this.ordemServico.dataFinal;
    this.horimetroInicial = this.ordemServico.horimetroInicial;
    this.horimetroFinal = this.ordemServico.horimetroFinal;
    this.horaInicio = this.ordemServico.horaInicial;
    this.horaFim = this.ordemServico.horaFinal;
    this.tipo = this.ordemServico.tipoOS;
    if (this.tipo == "PV") {
      this.carregar();
    } else {
      this.servicosL = JSON.parse(JSON.stringify(this.ordemServico.itens));
      this.servicosL.forEach((s) => {
        this.$set(s, "index", index++);
        this.$set(s, "execucao", s.executado ? 1 : 0);
        this.$set(s, "editingExecucao", false);
      });
    }
  },
  components: {
    Produto,
  },
};
</script>

<style scoped>
.os-action-speed-dial {
  right: calc(24px + env(safe-area-inset-right, 0px)) !important;
}

::v-deep .os-action-speed-dial .v-speed-dial__list {
  align-items: flex-end;
  left: auto !important;
  right: 0;
  width: max-content;
  max-width: calc(100vw - 48px);
}

::v-deep .os-action-speed-dial .os-action-button {
  margin: 6px 0 !important;
  max-width: calc(100vw - 48px);
}

@media (max-width: 600px) {
  .os-action-speed-dial {
    right: calc(16px + env(safe-area-inset-right, 0px)) !important;
  }

  ::v-deep .os-action-speed-dial .v-speed-dial__list,
  ::v-deep .os-action-speed-dial .os-action-button {
    max-width: calc(100vw - 32px);
  }
}
</style>
